export const routeTranslations = {
    about: {
        header: 'This is a test header'
    },
    admin: {
        dashboard: {
            label: 'Dashboard',
            title: 'Admin Dashboard'
        },
        clients: {
            label: 'Clients'
        },
        contacts: {
            label: 'Contacts'
        },
        export: {
            label: 'Export'
        },
        loans: {
            label: 'Loans'
        },
        loanGroups: {
            label: 'Loan Groups'
        },
        reports: {
            label: 'Reports'
        },
        settings: {
            label: 'Settings'
        },
        surveys: {
            label: 'Surveys',
            altLabel: 'Aspen Surveys'
        },
        financial: {
            label: 'Financial',
            altLabel: 'Financial Surveys'
        },
        users: {
            label: 'Users'
        }
    },
    client: {
        contacts: {
            label: 'Contacts',
            title: 'Contacts'
        },
        dashboard: {
            label: 'Dashboard',
            title: 'Client Dashboard'
        },
        exports: {
            label: 'Exports'
        },
        financials: {
            label: 'Financials'
        },
        goals: {
            label: 'Goals'
        },
        profile: {
            label: 'Profile'
        },
        reports: {
            label: 'Reports',
            children: {
                reportsAssetLiabilities: {
                    label: 'Asset Liabilities'
                },
                reportsPnl: {
                    label: 'Profit and Loss'
                }
            }
        },
        settings: {
            label: 'Settings'
        },
        surveys: {
            label: 'Surveys',
            title: 'Surveys'
        }
    },
    shared: {
        settings: {
            label: 'Settings',
            title: 'Account Settings'
        }
    }
};